import { render, staticRenderFns } from "./InputAsset.vue?vue&type=template&id=2391beb4&"
import script from "./InputAsset.vue?vue&type=script&lang=js&"
export * from "./InputAsset.vue?vue&type=script&lang=js&"
import style0 from "./InputAsset.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports